import ELK from 'elkjs/lib/elk.bundled.js';

// Instance unique ELK pour toute l'app
const elk = new ELK();

// Flag de disponibilité
let elkReady = false;
let elkReadyPromise: Promise<void> | null = null;

/**
 * Initialise ELK avec un test de canary (2 nodes).
 * Doit être appelé au démarrage de l'app.
 * Sécurisé contre les appels multiples.
 */
export async function initELK(): Promise<void> {
  if (elkReady) return;
  if (elkReadyPromise) return elkReadyPromise;

  elkReadyPromise = elk
    .layout({
      id: 'canary',
      layoutOptions: { 'elk.algorithm': 'layered' },
      children: [
        { id: 'a', width: 100, height: 50 },
        { id: 'b', width: 100, height: 50 },
      ],
      edges: [{ id: 'e', sources: ['a'], targets: ['b'] }],
    })
    .then(() => {
      elkReady = true;
      console.info('[ELK] Worker ready');
    })
    .catch((err) => {
      console.error('[ELK] Worker initialization failed:', err);
      elkReadyPromise = null;
    });

  return elkReadyPromise;
}

export function isELKReady(): boolean {
  return elkReady;
}

export default elk;
